module.exports = __webpack_public_path__ + "static/media/save.0b1d0d7d.svg";